<template>
  <v-form ref="form" class="">

    <BaseUtil ref="util" :pageLoading="pageLoading" />

    <v-tabs>
      <v-tab>Geral</v-tab>
      <v-tab>Endereços</v-tab>
      <v-tab v-if="entry.isCarrier">Veículos</v-tab>
      <v-tab v-if="entry.isCollaborator">Inscrições Estaduais</v-tab>
      <v-tab v-if="entry.isCustomer">Rotas</v-tab>
      <v-tab v-if="entry.isCustomer">Emb. de venda</v-tab>
      <v-tab v-if="entry.isCustomer && $can('access', 'Altavenda')">Culturas</v-tab>
      <v-tab>Contato</v-tab>
      <v-tab>Dados adicionais</v-tab>
      <v-tab v-if="false">Certificado digital</v-tab>

      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>
                    <span class="font-weight-regular body-1">Tipos de Pessoa</span>
                  </v-card-title>
                  <v-card-text>
                    <v-switch v-model="entry.isCustomer" inset :disabled="readOnly" label="Cliente"></v-switch>
                    <v-switch v-model="entry.isSupplier" inset :disabled="readOnly" label="Fornecedor"></v-switch>
                    <v-switch v-model="entry.isCarrier" inset :disabled="readOnly" label="Transportadora"></v-switch>
                    <v-switch v-model="entry.isCollaborator" inset :disabled="readOnly" label="Emitente NFe"></v-switch>
                    <v-switch v-model="entry.isEmployee" inset :disabled="readOnly" label="Funcionário"></v-switch>
                    <v-switch v-model="entry.isDriver" inset :disabled="readOnly" label="Motorista"></v-switch>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="9">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="ml-3 ml-sm-0">
                <v-radio-group v-model="entry.kind" v-bind="getObject('kind')" :disabled="readOnly">
                  <v-radio label="Física" :value="0"></v-radio>
                  <v-radio label="Jurídica" :value="1"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="6" md="5">
                <v-text-field v-model="entry.name" v-bind="getObject('name')"
                  :label="entry.kind == 0 ? 'Nome' : 'Razão Social'" autocomplete="off" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="entry.tradingName" v-bind="getObject('tradingName')"
                  :label="entry.kind == 0 ? 'Apelido' : 'Nome Fantasia'" autocomplete="off" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <MaskedTextField v-if="entry.kind == 0" v-bind="getObject('cpf')" :inputData.sync="entry.cpf"
                  mask-type="cpf" label="CPF" key="cpf" autocomplete="off" :disabled="readOnly" />
                <MaskedTextField v-bind="getObject('cnpj')" :inputData.sync="entry.cnpj" mask-type="cnpj" label="CNPJ"
                  v-else key="cnpj" autocomplete="off" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <MaskedTextField v-bind="getObject('rg')" :inputData.sync="entry.rg" mask-type="rg" label="RG"
                  :key="entry.isEmployee" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <DateField :inputData.sync="entry.birthDate" v-bind="getObject('birthDate')" label="Data de nascimento"
                  :hasTodayButton="false" :hasTodayDate="false" :disabled="readOnly" autocomplete="off" />
              </v-col>              

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="entry.labelId"
                  v-bind="getObject('labelId')"
                  label="Etiqueta"
                  :items="extraData.accountContext.allPeopleLabels"
                  item-value="id"
                  item-text="description"
                  clearable
                  @click:clear="$nextTick(() => entry.labelId = null)"
                  :disabled="readOnly"
                >
                  <template v-slot:selection="data">
                    <span>
                      <v-icon right :color="data.item.colorHexaCode" class="mr-2">mdi-circle</v-icon>
                      {{ data.item.description }}
                    </span>
                  </template>
                  <template v-slot:item="data">
                    <span>
                      <v-icon right :color="data.item.colorHexaCode" class="mr-2">mdi-circle</v-icon>
                      {{ data.item.description }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="entry.isCustomer">
                <v-autocomplete v-model="entry.tablePriceId" v-bind="getObject('tablePriceId')" label="Tabela de preço"
                  :items="extraData.accountContext.allTablePrices" item-value="id" item-text="name" clearable
                  @click:clear="$nextTick(() => entry.tablePriceId = null)" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="entry.isCustomer">
                <v-autocomplete v-model="entry.sellerId" v-bind="getObject('sellerId')"
                  label="Vendedor" :items="extraData.accountContext.allMyEmployees" item-value="id" item-text="name"
                  clearable @click:clear="$nextTick(() => entry.sellerId = null)" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="entry.isCustomer">
                <v-autocomplete v-model="entry.leadingCompanyId" v-bind="getObject('leadingCompanyId')"
                  label="Parceiro Comercial" :items="extraData.accountContext.allMyCustomers" item-value="id" item-text="name"
                  clearable @click:clear="$nextTick(() => entry.leadingCompanyId = null)" :disabled="readOnly" />
              </v-col>


              <v-col cols="12" sm="6" md="6" v-if="false">
                <v-autocomplete v-model="entry.regionId" v-bind="getObject('regionId')"
                  label="Região" :items="extraData.accountContext.allRegions" item-value="id" item-text="description"
                  clearable @click:clear="$nextTick(() => entry.regionId = null)" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="4" v-if="entry.isEmployee">
                <v-autocomplete v-model="entry.contractTypeId" v-bind="getObject('contractTypeId')"
                  label="Tipo de Contratação" :items="extraData.globalContext.allContractTypes" item-value="id"
                  item-text="name" clearable @click:clear="$nextTick(() => entry.contractTypeId = null)"
                  :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" md="4" v-if="entry.isEmployee">
                <MaskedTextField v-bind="getObject('hourlyPrice')" :inputData.sync="entry.hourlyPrice"
                  mask-type="currency" label="Preço por Hora" prefix="R$" :disabled="readOnly" />
              </v-col>

              <v-col cols="12" sm="6" v-if="entry.isEmployee">
                <v-text-field v-model="entry.role" v-bind="getObject('role')" label="Cargo" :disabled="readOnly" />
              </v-col>



            </v-row>
          </v-col>

        </v-row>
        <v-row v-if="entry.isCustomer || entry.isCollaborator || entry.isSupplier || entry.isCarrier">
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>
                <span class="font-weight-regular body-1">Dados Utilizados para Emissão de NF-e</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" v-if="entry.isCollaborator">
                    <v-autocomplete v-model="entry.taxRegimeId" v-bind="getObject('taxRegimeId')"
                      label="Código do Regime Tributário" :items="extraData.globalContext.allTaxRegimes" item-value="id"
                      item-text="description" clearable @click:clear="$nextTick(() => entry.taxRegimeId = null)"
                      autocomplete="new" :disabled="readOnly" />
                  </v-col>

                  <v-col cols="12" sm="6" v-if="entry.isCustomer || entry.isCarrier || entry.isSupplier">
                    <v-autocomplete v-model="entry.recipientStateInscriptionIndicatorId"
                      v-bind="getObject('recipientStateInscriptionIndicatorId')" label="Indicador da IE do destinatário"
                      :items="extraData.globalContext.allRecipientStateInscriptionIndicators" item-value="id"
                      item-text="description" clearable
                      @click:clear="$nextTick(() => entry.recipientStateInscriptionIndicatorId = null)"
                      autocomplete="new" :disabled="readOnly" />
                  </v-col>

                  <v-col cols="12" sm="6" v-if="entry.isCustomer || entry.isCarrier || entry.isSupplier">
                    <v-text-field v-model="entry.recipientStateInscription"
                      v-bind="getObject('recipientStateInscription')"
                      label="Inscrição Estadual do Cliente ou Transportadora" autocomplete="off" :disabled="readOnly" />
                  </v-col>

                  <v-col cols="12" sm="6" v-if="entry.isCustomer || entry.isSupplier || entry.isCarrier">
                    <v-text-field v-model="entry.taxReceiptEmail" v-bind="getObject('taxReceiptEmail')"
                      label="E-mail para Notas" autocomplete="off" inputmode="email" :disabled="readOnly" />
                  </v-col>

                  <v-col cols="12" sm="6" v-if="entry.isCustomer">
                    <v-switch v-model="entry.isFinalConsumer" v-bind="getObject('isFinalConsumer')" inset
                      label="Consumidor Final" :disabled="readOnly" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" class="">
            <AddressIndex :addresses="entry.addressesAttributes" :readOnly="readOnly" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item v-if="entry.isCarrier">
        <v-row>
          <v-col cols="12" class="">
            <PatrimonyPeopleIndex :patrimonies="entry.patrimoniesAttributes" :readOnly="readOnly" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item v-if="entry.isCollaborator">
        <v-row>
          <v-col cols="12" class="">
            <TaxPayerIndex :taxPayers="entry.taxPayersAttributes" :readOnly="readOnly" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item v-if="entry.isCustomer">
        <v-row>
          <v-col cols="12" class="">
            <MultiSelect v-model="entry.routeIdsAttribute" v-bind="getObject('routeIdsAttribute')" label="Rota(s)"
              :items="routesList" :loadingItems="routesListLoading" :readOnly="readOnly">
              <template v-slot:new_action>
                <RouteNew :inlineAddButton="true" @entry-created="routeCreated" :showNesteds="false"
                  modelNameSingular="Rota" />
              </template>
            </MultiSelect>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item v-if="entry.isCustomer">
        <v-row>
          <v-col cols="12" class="">
            <SalePackagingIndex :items="entry.salePackagingsAttributes" :readOnly="readOnly" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item v-if="entry.isCustomer && $can('access', 'Altavenda')">
        <v-row>
          <v-col cols="12" class="">
            <CustomerCulture :items="entry.customerCulturesAttributes" :readOnly="readOnly" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="entry.phone" v-bind="getObject('phone')" label="Telefone (com DDD)" v-mask="'(##) #########'" place-holder="(51)99999-0000"
                  autocomplete="off"   :disabled="readOnly" />
                <!-- <MaskedTextField
                  v-bind="getObject('phone')"
                  :inputData.sync="entry.phone"
                  mask-type="phone"
                  label="Telefone"
                /> -->
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="entry.cellPhone" v-bind="getObject('cellPhone')" v-mask="'(##) #########'" label="Celular (com DDD)"
                  autocomplete="off" inputmode="tel" :disabled="readOnly" />
                <!-- <MaskedTextField
                  v-bind="getObject('cellPhone')"
                  :inputData.sync="entry.cellPhone"
                  mask-type="phone"
                  label="Celular"
                /> -->
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="entry.email" v-bind="getObject('email')" label="E-mail" autocomplete="off"
                  inputmode="email" :disabled="readOnly" />
              </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
          v-bind="getObject('observation')"
          v-model="entry.observation"
          label="Observações"
          outlined
          autocomplete="off"
          :readonly="readOnly"
          />
        </v-col>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="12">
            <v-file-input label="Selecionar certificado" variant="underlined" v-model="file"></v-file-input>
          </v-col>
        </v-row>
      </v-tab-item>


    </v-tabs>

  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import AddressIndex from "@models/addresses/index.vue";
import PatrimonyPeopleIndex from "@models/patrimonies/patrimonies_people/index.vue";
import TaxPayerIndex from "@models/people/tax_payers/index.vue";
import BaseUtil from "@shared_components/base_util.vue";
import MultiSelect from "@shared_components/multi_select.vue";
import gql from 'graphql-tag';
import RouteNew from "@models/routes/new.vue";
import SalePackagingIndex from "@models/sale_packagings/index.vue";
import DateField from "@shared_components/date_field.vue";
import CustomerCulture from "@models/customer_cultures/index.vue";

export default {
  data() {
    return {
      file: null,
      entryAttributes: {},
      pageLoading: false,
      routesList: [],
      routesListLoading: false,
      selectedColor: null,
    };
  },
  watch: {
    "file": function () {
      // console.log("Alterou entry.periodIdsAttribute", this.entry.periodIdsAttribute)
      console.log(this.file);
      // this.entry = {};
      // this.entry.file ;
      // for (let index = 0; index < this.files.length; index++) {
      const element = this.file;
      var reader = new FileReader();
      var self = this;
      // console.log("self", self);
      reader.readAsDataURL(element);
      reader.onload = function () {
        // console.log(reader.result);
        // console.log("selfentry", self.entry);
        self.entry.cert = element.name + ";" + reader.result;
        // console.log("all", self.entry);
        // };
      }
    },
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    AddressIndex: AddressIndex,
    PatrimonyPeopleIndex: PatrimonyPeopleIndex,
    TaxPayerIndex: TaxPayerIndex,
    BaseUtil: BaseUtil,
    MultiSelect: MultiSelect,
    RouteNew: RouteNew,
    SalePackagingIndex: SalePackagingIndex,
    DateField: DateField,
    CustomerCulture: CustomerCulture,
  },
  created() {
    // console.log("form", this.entry);
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if (this.entry.isCustomer) {
      this.selectRoutes(false, true);
    }

    if(this.extraData.accountContext.allMyEmployees && this.extraData.accountContext.allMyEmployees.length == 1){
      this.entry.sellerId = this.extraData.accountContext.allMyEmployees[0].id;
    }
  },
  mounted() {
    // if (!this.entry.kind && this.entry.kind != 0) {
    //   this.entry.kind = 0;
    //   this.entry.isCustomer = true;
    //   this.entry.isCollaborator = false;
    //   this.entry.isSupplier = false;
    //   this.entry.isCarrier = false;
    // }
  },
  methods: {
    getObject: function (element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function () {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function () {
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function () {
      this.$refs.form.resetValidation();
    },
    selectRoutes: function (cleanRoute = false, verifyRoutesOnLoad = false) {
      this.routesListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_ROUTES_QUERY,
          fetchPolicy: "no-cache",
        })
        .then(response => {
          // console.log("response dos all periods", response)
          this.routesList = response.data.accountContext.allRoutes;

          if (cleanRoute) {
            this.entry.routeIdsAttribute = [];
          }

          if (verifyRoutesOnLoad) {
            this.routesList
            if (this.entry.routes && this.entry.routes.length > 0) {
              for (let route in this.entry.routes) {
                if (!this.routesList.some(routesList => routesList.id == this.entry.routes[route].id)) {
                  this.routesList.push(this.entry.routes[route]);
                  // console.log("route adicionado ", this.entry.periods[route]);
                }
              }
            }
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.routesListLoading = false));
    },
    selectRoute: function () {
      this.entry.routes = [];
      let notInList = [];
      this.peopleErrors = [];
      for (let index in this.entry.routeIdsAttribute) {
        let route = this.routesList.find(obj => obj.id == this.entry.routeIdsAttribute[index])
        if (route) {
          this.entry.routes.push(route);
        } else {
          notInList.push(this.entry.routeIdsAttribute[index]);
          this.entry.routeIdsAttribute.splice(index, 1);
        }
      }
      // console.log("notInList", notInList);
    },
    routeCreated: function (route) {
      this.routesList.unshift(route);
      this.entry.routeIdsAttribute.push(route.id);
    }
  }
};

const LOAD_ALL_ROUTES_QUERY = gql`
query {
	accountContext {
    allRoutes{
      id
      name
    }
    
  }
}`;
</script>

<style scoped>
.custom-square {
  width: 14px;
  height: 14px;
  display: inline-block;
  border-radius: 2px; /* Optional slight rounding for the square */
}

</style>
